module.exports = __webpack_public_path__ + "media/flags/eg-5d7ea40f.svg";